import pipe from '../utils/pipe.js';
import detectAutoplay from '../utils/detect-autoplay.js';

const createIntroStruct = function (introOpts) {
    return {
        dom: {
            el: introOpts.el,
            video: introOpts.el.querySelector('.intro-video')
        }
    };
};

const unmuteIntroVideo = function (introStruct) {
    const {
        dom
    } = introStruct;

    setTimeout(function () {
        dom.video.muted = false;
    });
};

const removeIntroEl = function (introStruct, transition) {
    const {
        dom
    } = introStruct;

    dom.el.classList.add(`transition-out${transition ? `-${transition}` : ''}`);

    setTimeout(function () {
        dom.el.parentNode.removeChild(dom.el);
    }, 500);
};

const launchIntro = async function (introStruct) {
    const {
        dom
    } = introStruct;
    const testPlayBuffer = 250;

    const autoplaySupport = await detectAutoplay(testPlayBuffer);

    if (autoplaySupport) {
        unmuteIntroVideo(introStruct);
    }

    dom.video.play();
};

const bindDomEvents = function (introStruct) {
    const {
        dom
    } = introStruct;

    dom.video.onended = () => { removeIntroEl(introStruct); };

    return introStruct;
};

const createIntroAPI = function (introStruct) {
    return {
        launch () {
            launchIntro(introStruct);
        }
    };
};

const Intro = function (introOpts) {
    const introStruct = createIntroStruct(introOpts);

    pipe(introStruct, [
        bindDomEvents
    ]);

    return createIntroAPI(introStruct);
};

export default Intro;



// WEBPACK FOOTER //
// ./assets/js/components/Intro.js